import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router-dom';
import { NAME_SPACE } from 'i18n';
import { FormPage, useRequestLoading, ButtonSave, ButtonBack } from 'shared';
import { PATH } from 'app.routes.const';
import { useTobaccoProduct } from './useTobaccoProduct';
import { FormTobaccoProduct } from './FormTobaccoProduct';

export function EditTobaccoProduct() {
  const { id } = useParams();
  const { product, createProduct, updateProduct, errorInfo, setErrorInfo } = useTobaccoProduct(id);
  const { t } = useTranslation(NAME_SPACE.TOBACCO_PRODUCTS);
  const $formRef = useRef(null);
  const history = useHistory();
  const { requestLoading, callbackRequest } = useRequestLoading();

  async function handleSubmit(product) {
    await callbackRequest(async () => {
      setErrorInfo({ message: '', detail: '' });
      id ? await updateProduct(product) : await createProduct(product);
      history.push(PATH.TOBACCO_PRODUCTS.LIST);
    });
  }

  function handleSaveClick() {
    $formRef.current.submit();
  }

  function handleGoBack() {
    history.push(PATH.TOBACCO_PRODUCTS.LIST);
  }

  function composeActionButtons() {
    const actionButtons = [
      { onClick: handleGoBack, component: ButtonBack },
      {
        onClick: handleSaveClick,
        enableOnDirty: true,
        component: ButtonSave
      }
    ];

    return actionButtons;
  }

  return (
    <FormPage
      title={t('singularName')}
      disabled={requestLoading}
      buttons={composeActionButtons()}
      onSubmit={handleSubmit}
    >
      <FormTobaccoProduct errors={errorInfo} formRef={$formRef} product={{ ...product }} />
    </FormPage>
  );
}
